import { Component, OnInit, ViewChild } from '@angular/core';
import {NgbDate, NgbCalendar, NgbDateStruct, NgbTimeStruct, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.css'],
    standalone: false
})
export class DatepickerComponent implements OnInit {
  model: NgbDateStruct;
  timeModel: NgbTimeStruct;
  date: {year: number, month: number, day: number};
  time: {hour: number, minute: number};

  @ViewChild('content', { static: true }) modalContent;

  constructor(private calendar: NgbCalendar,
              public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.date = this.calendar.getToday();
  }

  onDateSelection(date: NgbDate) {
    this.date = date;
  }

  onTimeSelection(date) {
    this.time = date;
  }
}
